import { oc } from "@orpc/contract";
import { openapi } from "@orpc/openapi";
import { z } from "zod";
import { accountRequiredMessage, errors, paxRoute, sessionRequired } from "../../common";
import { EarningsByDayResponse, EarningsQuery, EarningsStatus, UserParams } from "./schemas";

const earningsErrors = {
  ...errors.badRequest,
  ...sessionRequired,
  FORBIDDEN: { message: accountRequiredMessage },
  NOT_FOUND: { message: "No earnings you may read match that recipient and preset." },
} as const;

export const listDailyEarnings = oc
  .meta(
    paxRoute({ auth: { kind: "account" }, minimumTier: null, cost: "read" }),
    openapi({
      method: "GET",
      path: "/api/accounting/v1alpha1/daily-earnings",
      operationId: "accounting.dailyEarnings.list",
      summary: "List creator earnings by day.",
      description:
        "Returns the creator rewards paid to a recipient, from a preset, or both, added up per UTC day over a named range ending today.",
      inputStructure: "detailed",
      successDescription: "The matching earnings per day, and the days read.",
    }),
  )
  .errors(earningsErrors)
  .input(z.object({ query: EarningsQuery }))
  .output(EarningsByDayResponse);

export const getEarningsStatus = oc
  .meta(
    paxRoute({
      auth: {
        kind: "account",
        note: "Players read their own; reading another player's needs `credits.view`.",
      },
      minimumTier: null,
      cost: "read",
    }),
    openapi({
      method: "GET",
      path: "/api/accounting/v1alpha1/players/{userId}/earnings-status",
      operationId: "accounting.players.earningsStatus.get",
      summary: "Check whether a player has creator earnings.",
      description: "Returns whether the player has ever been paid a creator reward.",
      inputStructure: "detailed",
      successDescription: "Whether the player has creator earnings.",
    }),
  )
  .errors({
    ...errors.badRequest,
    ...sessionRequired,
    FORBIDDEN: { message: accountRequiredMessage },
  })
  .input(z.object({ params: UserParams }))
  .output(EarningsStatus);
